import { render } from "./BreadCrumb.vue?vue&type=template&id=3edf1957"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"
script.render = render

export default script